import React from "react";
import PropTypes from "prop-types";

const ActionButton = ({
  children,
  onClick,
  color = "african-green", // Default color
  disabled = false,
  type = "button", // Default type
  className = "", // Allow custom classes
  ...props // Pass other props like aria-label etc.
}) => (
  <button
    type={type}
    className={`px-4 py-2 rounded-md text-indigo-600 hover:text-indigo-900 font-semibold transition duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2 ${
      disabled
        ? "bg-gray-400 cursor-not-allowed"
        : `bg-${color}-500 hover:bg-${color}-700 focus:ring-${color}-500` // Added focus styles
    } ${className}`} // Merge default and custom classes
    onClick={onClick}
    disabled={disabled}
    {...props} // Spread remaining props
  >
    {children}
  </button>
);

ActionButton.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func, // Make onClick optional if type is 'submit' sometimes
  color: PropTypes.string,
  disabled: PropTypes.bool,
  type: PropTypes.oneOf(["button", "submit", "reset"]),
  className: PropTypes.string,
};

export default ActionButton;